import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Label, Button } from "../../common";
import moment from "moment";
import swal from "sweetalert";
import { deliverMaterial } from "../../../actions/commonDeliverMaterials";
import ImageUtils from "../../../helpers/ImageUtils";
import DatePicker from "react-datepicker";

export default function CommonMaterialDeliveryForm(props) {
  const dispatch = useDispatch();
  const selectedForDelivery = useSelector(
    (state) => state.commonDeliverMaterials.selectedForDelivery
  );
  const [checkedState, setCheckedState] = useState(
    new Array(selectedForDelivery.materials.length).fill(false)
  );
  const [inputFields, setInputFields] = useState(
    new Array(selectedForDelivery.materials.length).fill({
      stock_qty: 0,
    })
  );
  const [receivedBy, setReceivedBy] = useState("");
  const [deliveredDate, setDeliveredDate] = useState(new Date());
  const fileInputRef = useRef();
  const [selectedFile, setSelectedFile] = useState(null);

  const handleDeliveredDateChange = (date) => {
    setDeliveredDate(date);
  };

  const handleFileChange = (e) => {
    setSelectedFile(fileInputRef.current.files[0]);
  };

  const handleCheckboxChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );

    setCheckedState(updatedCheckedState);
  };

  const handleAllChecked = (event) => {
    const updatedCheckedState = checkedState.map(() => event.target.checked);

    setCheckedState(updatedCheckedState);
  };

  const handleInputChange = (position, event) => {
    const values = inputFields.map((item, index) => {
      if (index !== position) {
        return item;
      }

      return {
        ...item,
        [event.target.name]: event.target.value,
      };
    });

    setInputFields(values);
  };

  const onSubmit = () => {
    if (!selectedFile) {
      alert("Attachment is required.");
      return;
    }
    swal({
      icon: "warning",
      title: "Are you sure?",
      text: `This will tag the issued purchase order as delivered.`,
      buttons: true,
    }).then(async (willAdd) => {
      if (willAdd) {
        let file = null;
        if (selectedFile) {
          file = await ImageUtils.fileToBase64(selectedFile);
        }

        let selectedMaterials = [];
        selectedForDelivery.materials.forEach((material, index) => {
          if (checkedState[index] === true) {
            selectedMaterials.push({
              id: material.id,
              stock_qty: inputFields[index].stock_qty,
            });
          }
        });

        let data = {
          materials: selectedMaterials,
          common_issue_purchase_order_id: selectedForDelivery.id,
          received_by: receivedBy,
          delivered_date: moment(deliveredDate).format("YYYY-MM-DD").toString(),
        };

        data.attachment = file;

        dispatch(deliverMaterial(data));
        props.onFormClose && props.onFormClose();
      }
    });
  };

  return (
    <form>
      <h1 className="font-bold">Deliver Issued Order</h1>
      {selectedForDelivery && (
        <p className="text-xs text-gray-600 mb-4">
          Ref: {selectedForDelivery.ref_no}
        </p>
      )}

      <div className="flex mb-4">
        <div className="w-1/2">
          <Label name="Received by" />
          <input
            className="text-xs shadow appearance-none border rounded w-full py-2 px-3 mr-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            autoComplete="off"
            name="delivered_by"
            type="text"
            value={receivedBy}
            onChange={(e) => setReceivedBy(e.target.value)}
          />
        </div>

        <div className="w-1/2 px-4">
          <Label name="Date delivered" />
          <DatePicker
            showYearDropdown
            selected={deliveredDate}
            dateFormat="yyyy-MM-dd"
            onChange={handleDeliveredDateChange}
            className="text-xs shadow appearance-none border rounded w-full py-2 px-3 mr-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            style={{ zIndex: 10 }}
          />
        </div>
      </div>

      <div className="flex mb-4">
        <div className="w-1/2">
          <Label name="Attachment (optional)" />
          <input
            className="text-xs"
            ref={fileInputRef}
            type="file"
            onChange={(e) => {
              handleFileChange(e);
            }}
          />
        </div>
      </div>

      <p className="font-bold mt-4">Materials</p>
      <p className="text-xs text-gray-600">
        please choose materials that was delivered.
      </p>
      <p className="text-xs text-gray-600 mb-4">
        note: delivered quantity would be the actual stock count.
      </p>
      <div className="ml-4">
        <input
          name="select_all"
          type="checkbox"
          onChange={(e) => handleAllChecked(e)}
        />
        <label for="select_all" className="text-xs font-bold ml-4">
          Check/Uncheck All
        </label>
      </div>
      <table className="table-fixed w-100 mb-4">
        <thead>
          <tr>
            <th className="text-xs px-4 py-2">Select</th>
            <th className="text-xs px-4 py-2">Category</th>
            <th className="text-xs px-4 py-2">Code</th>
            <th className="text-xs px-4 py-2">Description</th>
            <th className="text-xs px-4 py-2">Unit</th>
            <th className="text-xs px-4 py-2">Price</th>
            <th className="text-xs px-4 py-2">Warehouse</th>
            <th className="text-xs px-4 py-2">Ordered Qty</th>
            <th className="text-xs px-4 py-2">
              Delivered Qty <br />
              (Stock Qty)
            </th>
          </tr>
        </thead>
        <tbody>
          {selectedForDelivery.materials.map((material, index) => (
            <tr key={index} className="hover:bg-gray-200">
              <td>
                <input
                  type="checkbox"
                  name="material_id[]"
                  checked={checkedState[index]}
                  onChange={() => handleCheckboxChange(index)}
                  className="ml-4"
                />
              </td>
              <td className="text-xs border px-2 py-2">
                {material.common_category.name}
              </td>
              <td className="text-xs border px-2 py-2">{material.code}</td>
              <td className="text-xs border px-2 py-2">
                {material.description}
              </td>
              <td className="text-xs border px-2 py-2">{material.unit}</td>
              <td className="text-xs border px-2 py-2">${material.price}</td>
              <td className="text-xs border px-2 py-2">
                {material.warehouse ? material.warehouse.name : ""}
              </td>
              <td className="text-xs border px-2 py-2">
                {material.common_issue_po_qty}
              </td>
              <td className="text-xs border px-2 py-2">
                <input
                  className="text-xs shadow appearance-none border rounded w-full py-2 px-3 mr-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  autoComplete="off"
                  id={`stock_qty-${index}`}
                  name="stock_qty"
                  type="text"
                  value={inputFields[index].stock_qty}
                  onChange={(event) => handleInputChange(index, event)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="justify-center flex mt-4 px-4">
        <Button
          text="Submit Delivered Orders"
          success="true"
          disabled={checkedState.filter(Boolean).length <= 0}
          onClick={() => {
            onSubmit();
          }}
        />
        <Button
          text="Close"
          primary="true"
          onClick={() => {
            props.onFormClose() && props.onFormClose();
          }}
        />
      </div>
    </form>
  );
}
